var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnvelope = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_envelope",
    "data-name": "Icon / envelope",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 11.25,
    viewBox: "0 0 15 11.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope",
    d: "M13.594,64H1.406A1.407,1.407,0,0,0,0,65.406v8.438A1.407,1.407,0,0,0,1.406,75.25H13.594A1.407,1.407,0,0,0,15,73.844V65.406A1.407,1.407,0,0,0,13.594,64Zm-12.187.938H13.594a.47.47,0,0,1,.469.469v1.213c-.642.542-1.559,1.289-4.412,3.554-.5.393-1.471,1.339-2.15,1.327-.68.012-1.658-.935-2.15-1.327C2.5,67.908,1.579,67.161.938,66.619V65.406A.47.47,0,0,1,1.406,64.938Zm12.188,9.375H1.406a.47.47,0,0,1-.469-.469V67.838c.668.548,1.723,1.395,3.829,3.067.6.48,1.661,1.538,2.733,1.532s2.118-1.04,2.733-1.532c2.106-1.673,3.161-2.52,3.829-3.067v6.006A.47.47,0,0,1,13.594,74.313Z",
    transform: "translate(0 -64)",
    fill: "#1a1a1a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnvelope);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/envelope.4e3e8c17fbb9adade8fe8cf3891ae6ad.svg";